<template>
  <div class="snow-checkbox" :class="[componentClasses, { indeterminate }]">
    <b-form-checkbox
      v-model="innerValue"
      :id="checkboxId"
      :name="String(id)"
      v-bind="isBoolean ? {} : { value: id, uncheckedValue }"
      :indeterminate="indeterminate"
      :disabled="disabled"
      @change="v => $emit('change', v, id)"
    >
      <slot>
        <div class="d-flex align-items-center ml-2 gap-2">
          <span :class="[{ 'fs-14': size == 'sm' }]">
            {{ name }}
            <span v-if="required" class="text-negative-700">*</span>
          </span>
          <bp-tooltip :text="warning" v-if="warning">
            <i class="text-red ph ph-info" />
          </bp-tooltip>
          <bp-tooltip :text="info" v-if="info">
            <i class="ph ph-question" />
          </bp-tooltip>
        </div>
      </slot>
    </b-form-checkbox>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean]
    },
    id: {
      type: [String, Number],
      required: true
    },
    name: {
      type: [String, Number],
      default: ""
    },
    uncheckedValue: {
      type: [String, Boolean],
      default: ""
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "lg",
      validation: v => ["sm", "lg"].includes(v)
    },
    required: {
      type: Boolean,
      default: false
    },
    warning: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    isBoolean: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      innerValue: this.isBoolean ? !!this.value : this.value
    };
  },
  computed: {
    componentClasses() {
      const componentClasses = [this.size];

      return componentClasses;
    },
    checkboxId() {
      const prefix = this.groupId ? `${this.groupId}-` : '';
      return `checkbox-${prefix}${this.id}`;
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = this.isBoolean ? !!newVal : newVal;
    },
    innerValue(newVal) {
      const output = this.isBoolean ? !!newVal : newVal;
      if (output !== this.value) this.$emit("input", output);
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-checkbox {
  position: relative;

  ::v-deep {
    .custom-control.custom-checkbox {
      position: unset;
      display: flex;
      align-items: center;
      padding-left: 24px;

      .custom-control-input {
        top: 3px;
        left: 6px;
        width: 18px;
        height: 18px;
        @media screen and (max-width: 667px) {
          top: 2px;
          width: 20px;
          height: 20px;
        }
      }

      .custom-control-label {
        display: flex;
        min-height: 24px;
        align-items: center;

        &::before {
          box-shadow: unset;
          border-radius: 5px;
          border: 1px solid var(--dark-20);
        }
        &::before,
        &::after {
          top: 3px;
          left: -18px;
          width: 18px;
          height: 18px;
          @media screen and (max-width: 667px) {
            top: 2px;
            width: 20px;
            height: 20px;
          }
        }
      }
      &:has(input:checked) {
        .custom-control-label {
          &::before {
            background-color: black;
            border-color: black;
          }
        }
      }
    }
    .custom-checkbox
      .custom-control-input:indeterminate
      ~ .custom-control-label::before {
      background-color: black;
      border-color: black;
    }
  }
  &.lg {
    ::v-deep {
      .custom-control.custom-checkbox {
        .custom-control-label {
          &::before,
          &::after {
            @media screen and (max-width: 667px) {
              top: 3px;
            }
          }
        }
        .custom-control-input {
          @media screen and (max-width: 667px) {
            top: 3px;
          }
        }
      }
    }
  }
}
</style>
